module.exports = __webpack_public_path__ + "img/companyLogo.205c37c5.png";